import AbstractApi, { type RequestConfig } from '@/api/AbstractApi';

export default class AbstractHybrisApi extends AbstractApi {
  /**
   * Set to 'false' skips to dev safety checks.
   */
  baseStore: string | boolean = '';

  constructor(config: RequestConfig) {
    super(config);

    this.baseUrl = config.public.hybrisBaseUrl;
    this.basePath = config.public.hybrisApiPath;

    // Handles the following cases:
    //  - Nitro server: no access to pinia, nor has pinia been populated -> explicitly pass baseStore (but not always)
    //  - I18N language file: has access to pinia, but runs before populating the store -> explicitly pass baseStore
    //  - Nuxt context: has access to pinia, and we make sure to populate pinia before using API -> less boilerplate
    if (this.baseStore !== false && config.baseStore) {
      this.baseStore = config.baseStore;

      if (import.meta.dev && !this.baseStore) {
        throw createError({
          statusCode: 500,
          statusMessage: `Missing 'baseStore' in '${this.constructor.name}' config.`,
        });
      }
    }
  }

  override getURL(endpoint: string, version: string) {
    const basePath = version ? `/rest/${version}` : this.basePath;
    return `${this.baseUrl}${basePath}/${this.baseStore || ''}${endpoint}`;
  }
}
